import User from '../user/class';

class Project {
  constructor(data) {
    this._id = data._id;
    this.workspace = data.workspace;
    this.type = data.type;
    this.name = data.name;
    this.description = data.description;
    this.urls = data.urls;
    this.moreInfoUrl = data.moreInfoUrl;
    this.users = data.users && data.users.map((u) => new User(u));
    this.logoUrl = data.logoUrl;
  }
}

export default Project;



// WEBPACK FOOTER //
// ./src/projects/class.js